import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import '../../queries/get-appointment-by-token.js';
import { GET_APPOINTMENT_BY_ID } from '../../queries/get-appointment-by-id.js';
import '../../queries/get-store-by-code.js';
import '../../queries/reschedule-appointment-by-id.js';
import '../../queries/reschedule-appointment-by-token.js';
import { fromAppointmentQueryToAppointment } from './adapters/fromAppointmentQueryToAppointment.js';

const useAppointmentById = (variables, token = '')=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_APPOINTMENT_BY_ID, {
        variables,
        context: {
            fetchPolicy: 'no-cache',
            forwardHeaders: {
                'Accept-Language': locale,
                Authorization: `Bearer ${token}`
            }
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.appointment) ? fromAppointmentQueryToAppointment(queryState.data.appointment) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};

export { useAppointmentById as default };
//# sourceMappingURL=use-appointment-by-id.js.map
